import { useRelatedProducts, useLookingSimilar } from 'react-instantsearch';

import type { InstantSearchResult } from '@javascript/types/InstantSearch';

export const combineRecommendedVehicles = (
  a: InstantSearchResult[] = [],
  b: InstantSearchResult[] = [],
  sourceA: string = 'a',
  sourceB: string = 'b',
) => {
  const result: InstantSearchResult[] = [];
  const max = Math.max(a.length, b.length);
  for (let i = 0; i < max; i++) {
    if (i < a.length) result.push({ ...a[i], source: sourceA });
    if (i < b.length) result.push({ ...b[i], source: sourceB });
  }
  // Remove duplicates based on objectID
  const uniqueResults = Array.from(
    new Map(result.map((item) => [item.objectID, item])).values(),
  );
  return uniqueResults.slice(0, 24);
};

const useRecommendations = (stockReference: string, cashPriceRange: string) => {
  const filters = `("isReserved":"false")${
    cashPriceRange ? ` AND ("cashPriceRange":"${cashPriceRange}")` : ''
  }`;

  const { items: relatedVehicles } = useRelatedProducts<InstantSearchResult>({
    objectIDs: [stockReference],
    queryParameters: { clickAnalytics: true, filters },
    threshold: 50,
  });

  const { items: looksSimilar } = useLookingSimilar<InstantSearchResult>({
    objectIDs: [stockReference],
    queryParameters: { clickAnalytics: true, filters },
    threshold: 50,
  });

  return combineRecommendedVehicles(
    relatedVehicles,
    looksSimilar,
    'related vehicles',
    'looks similar',
  );
};

export default useRecommendations;
